export default "__VITE_ASSET__BFjDdbud__"